<template>
   <vue-pdf-app :pdf="url" :theme="dark ? 'dark': 'light'" ></vue-pdf-app>
</template>

<script>
import webmms from "webmms-client";
import { set as setCookie, get as getCookie, remove as removeCookie } from "es-cookie";
import conf from '@/config/config';
import VuePdfApp from "vue-pdf-app";
import "vue-pdf-app/dist/icons/main.css";

export default {
  name: 'Image',
  props: ['pageParams'],
  data() {
    return {
      url: null,
      dark: false,
      eiInfo: {
          eiName: '',
          eiTag: '',
          ddn : ''
      },
       webmmsOptions : {
            EiToken: '',
            SToken: '',
            UToken: ''
      },
      error: true,
      timeout: 0,
      mmsReady: false,
      mms: null
    };
  },
  components: {
    VuePdfApp
  },
  async created() {
   this.readQueryParam();
   this.startMMS();
  },
  async beforeMount() {
     await this.subscribeMMS();
  },
  beforeDestroy() {
      this.removeEvent();
  },
  methods: {
    startMMS(){
          this.mms =  webmms({
            wsurl: conf.wsurl,
            EiToken: getCookie("pdf-EiToken") || "",
            SToken: getCookie("pdf-SToken") || ""
          });
    },
     readQueryParam(){
        let { url,dark } = this.pageParams;
        this.url = url;
        this.dark = dark;
    },
    async subscribeMMS() {
        this.removeEvent = this.mms.on("registered", async reply => {
            //console.log('reply=%s', JSON.stringify(reply))
             if(reply.ErrMsg == "OK"){
                this.eiInfo.ddn = reply.result.DDN;
                this.webmmsOptions.EiToken = reply.result.EiToken;
                this.webmmsOptions.SToken = reply.result.SToken;
                this.webmmsOptions.UToken = reply.result.UToken;
                if(this.eiInfo.eiName == ''){
                  this.eiInfo.eiName = reply.result.EiName ? reply.result.EiName : 'pgPDF' + this.makeId(5);
                }
                 if(this.eiInfo.eiTag == ''){
                  this.eiInfo.eiTag = reply.result.EiTag ? reply.result.EiTag : '';
                }
             }

             let expiredTime = 60 * 60 * 24 * 30 * 12;

             setCookie("pdf-EiToken", this.webmmsOptions.EiToken);
             setCookie("pdf-SToken", this.webmmsOptions.SToken);


             console.log('regtoCenter: %s', reply.ErrMsg);
             this.mmsReady = true;
             this.error = false;
             let deviceInfo = {"DDN":this.eiInfo.ddn,"EiOwner":"","EiName":this.eiInfo.eiName,"EiType":".page","EiTag":this.eiInfo.eiTag,"EiLoc":""};
             let result = await this.mms.setDeviceInfo(deviceInfo);
             console.log('SetDevice reply=%s', JSON.stringify(result));
             await this.track(this.mms, 'pdf', this.pageParams);
        });

        this.mms.on('message', (method, from, data, retcb) => {
              this.mmsReady = true;
             this.error = false;
             console.log('rcve: from=%s, data=%s', from, JSON.stringify(data));
            if ( typeof retcb == 'function') retcb({"ErrCode":0, "ErrMsg":"OK"})
        });

        this.mms.on('state', msg => {
            console.log('WS error: %s', msg);
            this.mmsReady = false;
            this.error = true;
        });

        this.mms.on('disconnect', msg => {
            this.mmsReady = false;
            this.error = true;
        });

        this.mms.on('error', err => {
             this.mmsReady = false;
            this.error = true;
        });

        this.mms.on('connect_error', err => {
             this.mmsReady = false;
            this.error = true;
        });

        this.mms.on('connect_timeout', err => {
            this.mmsReady = false;
            this.error = true;
        });
      }
  }
};
</script>

<style lang="scss">
iframe {
    z-index: 9999
}
</style>

